module.exports = __webpack_public_path__ + "static/media/black circle.e42e3252.png";